module.exports = __webpack_public_path__ + "img/lawOffice-3.245ddd5b.png";